export default "__VITE_ASSET__Dtb$_UP1__"